import { render, staticRenderFns } from "./SectionView.vue?vue&type=template&id=367b8fe3&scoped=true"
import script from "./SectionView.vue?vue&type=script&lang=js"
export * from "./SectionView.vue?vue&type=script&lang=js"
import style0 from "./SectionView.vue?vue&type=style&index=0&id=367b8fe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b8fe3",
  null
  
)

export default component.exports